export default "__VITE_ASSET__CUvdW_sh__"